import styled from 'styled-components'
import { Flex as AntFlex, Button as AntButton, Typography as AntTypography } from 'antd'
import { SPACING, MEDIA, COLORS, TYPOGRAPHY, FONT_WEIGHT } from '../../styles/theme'

const { Title: AntTitle } = AntTypography

/**
 * Styled components for LoginPage
 * Replaces all inline styles with reusable styled components
 */

// Main container with gradient background
export const PageContainer = styled(AntFlex)<{ $colorPrimary: string; $colorBgContainer: string }>`
  min-height: 100dvh;
  background: linear-gradient(135deg, var(--color-primary-bg) 0%, ${COLORS.bgPrimary} 100%);
  padding: 20px;
  position: relative;
`

// Logo link positioned at top-left
export const LogoLink = styled.a<{ $color?: string }>`
  position: absolute;
  top: 24px;
  left: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.bold};
  color: ${COLORS.textPrimary};
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  ${MEDIA.mobile} {
    top: 16px;
    left: 16px;
    font-size: ${TYPOGRAPHY.body.fontSize};
  }
`

// Card container for login/signup forms
export const CardContainer = styled.div<{
  $colorBgContainer: string
  $borderRadius: number
  $boxShadowTertiary: string
}>`
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: ${COLORS.bgCard};
  border-radius: ${(props) => props.$borderRadius * 2}px;
  box-shadow: var(--shadow-card);
`

// Centered title with no margin
export const CenteredTitle = styled(AntTitle)`
  && {
    text-align: center;
    margin: 0;
  }
`

// Alert description with word-break handling
export const AlertDescription = styled.div`
  word-break: normal;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.5;
`

// Alert description with word-break and no hyphens
export const AlertDescriptionNoHyphens = styled.div`
  word-break: normal;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.5;
  hyphens: none;
`

// Flex container with margin-bottom
export const FlexWithMargin = styled(AntFlex)`
  margin-bottom: ${SPACING.xl};
`

// Full width button
export const FullWidthButton = styled(AntButton)`
  && {
    width: 100%;
  }
`

// Link button with compact styling
export const CompactLinkButton = styled(AntButton)`
  && {
    padding: 0;
    height: auto;
  }
`
